module.exports = __webpack_public_path__ + "static/media/foodprint_app2_preview.a0286f13.jpg";